import React, { useState, useContext } from 'react';
import { Context } from '@store/store';

import { ControlledMenu, MenuItem, MenuHeader, MenuDivider } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import { 
  AiModal,
  AiModalCloseBtn,
  AiModalHeader,
  AiModalBody,
  AiModalStyledTextHolder,
  AiTextLoadingPlaceholder,
} from './page-context-menu.styles';

import { PROCESS_TEXT_USING_AI } from '@graphql/ai';
import { useMutation } from '@apollo/client';

const PageContextMenu = (props) => {
  const [state, dispatch] = useContext(Context);

  const {getContextMenuState, setContextMenuState, getContextMenuAnchorPoint, setContextMenuAnchorPoint, getContent} = props;
  
  const [getAiTextHeader, setAiTextHeader] = useState('');
  const [getAiText, setAiText] = useState('');
  const [getAiTextStatus, setAiTextStatus] = useState('WAITING');

  const [processTextUsingAi, { data:dataUpdate, loading:loadingUpdate, error:errorUpdate }] = useMutation(PROCESS_TEXT_USING_AI);

  const getSelectionText = function () {
    var text = "";
    if (window.getSelection) {
        text = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
        text = document.selection.createRange().text;
    }
    return text;
  }
  
  const processClickOnAiContextMenuItem = (e, setContextMenuState, newState, setAiText) => {
    e.syntheticEvent.target.classList.add('szh-menu__item--hover');
    setContextMenuState(newState);
    
    let originalText = getSelectionText();

    setAiTextStatus('WAITING');
    setAiText('');
    let context = null;
    if (newState == 'EXPLAIN_TERM') {
      context = document.getElementById('page-container').textContent;
    }
    processTextUsingAi({
      variables: {
        text: originalText,
        context: context,
        mode: newState,
      }
    }).then((res) => {
      const processedText = res.data.aiTextProcessingProcessText;
      if (processedText) {
        setAiTextStatus('FINISHED');
        setAiText(processedText);
      } else {
        setAiTextStatus('FAILED');
        setAiText("К сожалению, предоставленный текст обработать не удалось.");
      }
    })
  }

  const buildContextMenuContentByState = (contextMenuState) => {
    if (['OPENED_BY_RIGHTCLICK'].includes(contextMenuState)) {
      return (
        <>
          
          <>
            <MenuItem onClick={(e) => processClickOnCopy()}>Копировать</MenuItem>
            <MenuDivider />
          </>
          <MenuHeader>ИИ-тексты:</MenuHeader>
          
          { state.bookIsEligibleForAiTools ? 
            (
              (countWordsInSelectedText() > 5) ? (
                <>
                  <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'SUMMARIZE_BY_POINTS', setAiText)}>Извлечь ключевые моменты</MenuItem>
                  <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'GENERATE_QUESTIONS', setAiText)}>Сгенерировать вопросы</MenuItem>
                  <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'EXPLAIN_THIS', setAiText)}>Объяснить простыми словами</MenuItem>
                </>
              ) : (
                <>
                  <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'EXPLAIN_TERM', setAiText)}>Объяснить значение выделенного {(countWordsInSelectedText() == 1) ? 'слова' : 'словосочетания' }</MenuItem>
                </>
              )
            ) : (
              <MenuItem disabled={true}>К сожалению, ИИ-тексты недоступны<br/>для языка данного документа</MenuItem>
            )
          }
        </>
      );
    }

    const buildAiTextHeaderByState = (contextMenuState) => {
      if (contextMenuState == 'IMPROVE_WRITING') {
        return 'Улучшенный ИИ текст:';
      }
      if (contextMenuState == 'SUMMARIZE_BY_POINTS') {
        return 'Извлеченные из выделенного текста ключевые моменты:';
      }
      
      if (contextMenuState == 'GENERATE_QUESTIONS') {
        return 'Сгенерированные вопросы по выделенному тексту:';
      }
      if (contextMenuState == 'EXPLAIN_THIS') {
        return 'Объяснение выделенного текста от ИИ:';
      }
      if (contextMenuState == 'EXPLAIN_TERM') {
        return 'Объяснение от ИИ:';
      }
    }

    const statesWithTextHolder = [
      'IMPROVE_WRITING',
      'SUMMARIZE_BY_POINTS',
      'GENERATE_QUESTIONS',      
      'EXPLAIN_THIS',
      'EXPLAIN_TERM',
    ];
    if (statesWithTextHolder.includes(contextMenuState)) {
      return (
        <AiModal>
          <AiModalCloseBtn onClick={(e) => setContextMenuState('CLOSED')}>&times;</AiModalCloseBtn>
          <AiModalHeader>{buildAiTextHeaderByState(contextMenuState)}</AiModalHeader>
          <AiModalBody>
            <AiModalStyledTextHolder readonly={ ['WAITING', 'FAILED'].includes(getAiTextStatus) }>
              { getAiTextStatus == 'WAITING'
                ? (<AiTextLoadingPlaceholder>Подождите, идёт обработка текста...</AiTextLoadingPlaceholder>)
                : getAiText
              }
            </AiModalStyledTextHolder>
          </AiModalBody>
        </AiModal>
      );
    }
    return (<></>);
  }

  const countWordsInSelectedText = () => {
    const selectedText = getSelectionText();
    if (selectedText == null) {
      return 0;
    }

    const wordsCnt = getSelectionText().trim().split(/\s+/).length;
    return wordsCnt;
  };

  const processClickOnCopy = () => {
    let selectedText = getSelectionText();
    if (selectedText) {
      document.execCommand('copy');
    }
    setContextMenuState('CLOSED');
  };

  const handleOnBlur = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (e.target.classList.contains('szh-menu__item--hover')) {
      return;
    }
    if (e?.currentTarget?.contains(e?.relatedTarget)) {
      return;
    }
    if (document.activeElement == e.target) {
      return;
    }

    setContextMenuState('CLOSED');
  }

  return (
    <ControlledMenu
      anchorPoint={getContextMenuAnchorPoint}
      state={(getContextMenuState != 'CLOSED') ? 'open' : 'closed'}
      direction="right"
      onBlur={(e) => handleOnBlur(e)}
    >
      {buildContextMenuContentByState(getContextMenuState)}
    </ControlledMenu>
  );
};

export default PageContextMenu;